import React, { MutableRefObject, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';

import { useAppState } from './useCreateCustomComponentAppState';
import { useAngularEventOn } from '../../../../hooks/useAngularEventOn';

// components
import { CustomComponentsList } from '../components/CustomComponentsList';
// @ts-ignore
import ArrowSvg from '../svg/Arrow.svg';
import styled from 'styled-components';

type CreateCustomComponentMenuProps = {};

const Style = styled.div`
    &&& {
        width: 325px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        position: absolute;
        left: 75px;
        top: 10px;
        bottom: 10px;
        padding: 0;
        display: flex;
        flex-direction: column;
        z-index: 300;
        user-select: none;
    }
`;

const StyleArrow = styled.div`
    &&& {
        position: absolute;
        left: -13px;
        top: 208px;
    }
`;

export const CreateCustomComponentsMenu: React.FC<CreateCustomComponentMenuProps> = () => {
    const { state, actions } = useAppState();
    const containerRef = useRef<HTMLElement>() as MutableRefObject<HTMLElement>;

    useAngularEventOn('react:show-custom-components-menu', (e: any, data: any) => {
        actions.show();
    });

    const handleDragStart = () => {
        setTimeout(() => {
            if (containerRef.current) {
                containerRef.current.style.visibility = 'hidden';
            }
        }, 0);
    };

    const handleDragEnd = () => {
        if (containerRef.current) {
            containerRef.current.style.visibility = '';
        }
    };

    useEffect(() => {
        const handleDrop = (e: any) => {
            if (containerRef.current) {
                containerRef.current.style.opacity = '0';
                setTimeout(() => actions.hide());
            }
        };
        window.addEventListener('drop', handleDrop, true);
        return () => window.removeEventListener('drop', handleDrop, true);
        // eslint-disable-next-line
    }, []);

    if (state.isVisible) {
        return ReactDOM.createPortal(
            <OutsideClickHandler onOutsideClick={actions.hide}>
                {/*@ts-ignore */}
                <Style
                    ref={containerRef as any}
                    onDragStart={handleDragStart}
                    onDragEnd={handleDragEnd}
                    className="custom-components-container"
                >
                    <StyleArrow>
                        <ArrowSvg />
                    </StyleArrow>

                    <CustomComponentsList />
                </Style>
            </OutsideClickHandler>,
            document.querySelector('.z-wrapper-ng-view') as Element,
        );
    }

    return null;
};
